import React from 'react'
import set from 'lodash.set'

import { updateEventFeed } from '../../../services/data-explorer'
import { useRequestConfig } from '_hooks'
import { useEventFeedsContext } from '../../pages/event-feeds/context/index.jsx'
import ChartScaleSelect from '../chart-scale-select'

const ChartScaleSelectStored = ({ visualizationsPath }) => {
  const { id, data, dispatch, ACTIONS } = useEventFeedsContext()
  const { scale: chartScale } = useRequestConfig(visualizationsPath)

  const persistChartScale = (chartScaleValue) => {
    const newValue = { ...data?.visualizations }

    set(newValue, visualizationsPath + '.scale', chartScaleValue)

    const newData = { ...data, visualizations: newValue }
    updateEventFeed(id, newData)
    dispatch({ type: ACTIONS.SET_DATA, payload: newData })
  }

  return (
    <If condition={data?._id || id === 'discovery'}>
      <ChartScaleSelect
        chartScale={chartScale}
        onChartScaleChange={(chartScaleValue) => persistChartScale(chartScaleValue)}
      />
    </If>
  )
}

export default ChartScaleSelectStored
